// Precarga offline de las mantenciones iniciadas. Recorre la lista de solicitudes,
// filtra las EN_CURSO y baja su dato base (GET /mantenciones/:id) a IndexedDB, para
// que el técnico pueda abrirlas sin señal. Best-effort por ítem (Promise.allSettled).
import axios from 'axios';
import { API_PATH } from 'config';
import { getAccessTokenApi } from 'api/auth';
import { SOLICITUD_TIPOS } from 'assets/data/SolicitudesEstados';
import { saveMantencionBase } from 'utils/offlineMantencionBaseStore';
import { saveSolicitudes } from 'utils/offlineSolicitudesStore';

export async function prefetchMantencionesIniciadas(list) {
  if (!Array.isArray(list)) return { intentadas: 0, guardadas: 0 };
  const iniciadas = list.filter(
    (s) => s?.status === SOLICITUD_TIPOS.EN_CURSO && s?.id_mantencion != null
  );
  const token = getAccessTokenApi();
  const results = await Promise.allSettled(
    iniciadas.map(async (s) => {
      const { data } = await axios.get(`${API_PATH}/mantenciones/${s.id_mantencion}`, {
        headers: { Authorization: token },
      });
      await saveMantencionBase(s.id_mantencion, data);
    })
  );
  return {
    intentadas: iniciadas.length,
    guardadas: results.filter((r) => r.status === 'fulfilled').length,
  };
}

// Usada por el daemon al reconectar: refresca la lista y re-prefetchea.
export async function refreshSolicitudesCache() {
  try {
    const { data } = await axios.get(`${API_PATH}/solicitudes`, {
      headers: { Authorization: getAccessTokenApi() },
    });
    if (Array.isArray(data)) {
      await saveSolicitudes(data);
      await prefetchMantencionesIniciadas(data);
    }
  } catch {
    // best-effort
  }
}
